import { combineEpics } from 'redux-observable';

import { videoCreatorEditEpics } from '../VideoCreatorEditPage/epics';
import { videoCreatorImageUploaderEpics } from '../VideoCreatorImageUploader/epics';
import { videoCreatorMyVideoPageEpics } from '../VideoCreatorMyVideoPage/epics';
import { videoCreatorTemplatesListPageEpics } from '../VideoCreatorTemplatesListPage/epics';

export const videoCreatorEpics = combineEpics(
    videoCreatorEditEpics,
    videoCreatorImageUploaderEpics,
    videoCreatorMyVideoPageEpics,
    videoCreatorTemplatesListPageEpics
);
